/*
**    物流预警相关路由
*/
export default [{
    path: 'deliveredWarn',
    name: 'deliveredWarn',
    meta: {
      title: '妥投异常预警统计'
    },
    component: () =>
      import( /* webpackChunkName: "pop-deliveredWarn" */ '../views/transferWarning/delivered.vue')
  }, {
    path: 'detentionWarn',
    name: 'detentionWarn',
    meta: {
      title: '同城滞留异常预警统计'
    },
    component: () =>
      import( /* webpackChunkName: "pop-orderDelivery" */ '../views/transferWarning/detention.vue')
  },
  {
    path: 'collectionWarn',
    name: 'collectionWarn',
    meta: {
      title: '揽件异常预警统计'
    },
    component: () =>
      import( /* webpackChunkName: "pop-orderDelivery" */ '../views/transferWarning/collection.vue')
  }, {
    path: 'walkWarn',
    name: 'walkWarn',
    meta: {
      title: '走件异常预警统计'
    },
    component: () =>
      import( /* webpackChunkName: "pop-orderDelivery" */ '../views/transferWarning/walkingPiece.vue')
  }
]